import { Link } from 'react-router-dom';

export default function Footer() {
  const villes = [
    { name: 'Villeurbanne', href: '/reparation-fenetre-villeurbanne' },
    { name: 'Vénissieux', href: '/reparation-fenetre-venissieux' },
    { name: 'Caluire-et-Cuire', href: '/reparation-fenetre-caluire-et-cuire' },
    { name: 'Saint-Priest', href: '/reparation-fenetre-saint-priest' },
    { name: 'Vaulx-en-Velin', href: '/reparation-fenetre-vaulx-en-velin' },
    { name: 'Bron', href: '/reparation-fenetre-bron' },
    { name: 'Meyzieu', href: '/reparation-fenetre-meyzieu' },
    { name: 'Rillieux-la-Pape', href: '/reparation-fenetre-rillieux-la-pape' },
    { name: 'Décines-Charpieu', href: '/reparation-fenetre-decines-charpieu' },
    { name: 'Oullins', href: '/reparation-fenetre-oullins' },
    { name: 'Sainte-Foy-lès-Lyon', href: '/reparation-fenetre-sainte-foy-les-lyon' },
    { name: 'Tassin-la-Demi-Lune', href: '/reparation-fenetre-tassin-la-demi-lune' },
    { name: 'Écully', href: '/reparation-fenetre-ecully' },
    { name: 'Givors', href: '/reparation-fenetre-givors' },
    { name: 'Francheville', href: '/reparation-fenetre-francheville' },
    { name: 'Corbas', href: '/reparation-fenetre-corbas' },
    { name: 'Genas', href: '/reparation-fenetre-genas' },
    { name: 'Mions', href: '/reparation-fenetre-mions' },
    { name: 'Brignais', href: '/reparation-fenetre-brignais' },
    { name: 'Grigny', href: '/reparation-fenetre-grigny' },
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-50 to-gray-100 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Fenêtres Lyon</h3>
            <p className="text-gray-600 mb-6">
              Votre plateforme de mise en relation avec des artisans qualifiés pour la réparation de fenêtres à Lyon et dans le Rhône (69).
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                className="w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center text-white hover:bg-teal-700 transition-colors"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center text-white hover:bg-teal-700 transition-colors"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center text-white hover:bg-teal-700 transition-colors"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold text-gray-900 mb-4">Liens rapides</h4>
            <ul className="space-y-3">
              <li>
                <a href="/#services" className="text-gray-600 hover:text-teal-600 transition-colors">
                  Nos services
                </a>
              </li>
              <li>
                <a href="/comment-ca-marche" className="text-gray-600 hover:text-teal-600 transition-colors">
                  Comment ça marche ?
                </a>
              </li>
              <li>
                <a href="/#about" className="text-gray-600 hover:text-teal-600 transition-colors">
                  À propos
                </a>
              </li>
              <li>
                <a href="/#zone-intervention" className="text-gray-600 hover:text-teal-600 transition-colors">
                  Zone d'intervention
                </a>
              </li>
              <li>
                <a href="/#contact" className="text-gray-600 hover:text-teal-600 transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold text-gray-900 mb-4">Nos services</h4>
            <ul className="space-y-3">
              <li>
                <a href="/reparation-fenetre-pvc-lyon" className="text-gray-600 hover:text-teal-600 transition-colors">
                  Réparation fenêtre PVC
                </a>
              </li>
              <li>
                <a href="/reparation-fenetre-alu-lyon" className="text-gray-600 hover:text-teal-600 transition-colors">
                  Réparation fenêtre alu
                </a>
              </li>
              <li>
                <a href="/reparation-fenetre-bois-lyon" className="text-gray-600 hover:text-teal-600 transition-colors">
                  Réparation fenêtre bois
                </a>
              </li>
              <li>
                <a href="/reparation-baie-vitree-lyon" className="text-gray-600 hover:text-teal-600 transition-colors">
                  Réparation baie vitrée
                </a>
              </li>
              <li>
                <a href="/remplacement-quincaillerie-fenetre-lyon" className="text-gray-600 hover:text-teal-600 transition-colors">
                  Remplacement quincaillerie
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold text-gray-900 mb-4">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-teal-600 text-xl mt-1"></i>
                <div>
                  <p className="text-sm text-gray-500 mb-1">Téléphone</p>
                  <a href="tel:0980803684" className="text-gray-900 font-medium hover:text-teal-600 transition-colors">
                    09 80 80 36 84
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-teal-600 text-xl mt-1"></i>
                <div>
                  <p className="text-sm text-gray-500 mb-1">Email</p>
                  <a href="mailto:info@fenetreslyon.fr" className="text-gray-900 font-medium hover:text-teal-600 transition-colors">
                    info@fenetreslyon.fr
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-teal-600 text-xl mt-1"></i>
                <div>
                  <p className="text-sm text-gray-500 mb-1">Zone d'intervention</p>
                  <p className="text-gray-900 font-medium">Lyon et Rhône (69)</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Villes Section - SEO Internal Linking */}
        <div className="border-t border-gray-300 pt-8 mb-8">
          <h4 className="text-lg font-bold text-gray-900 mb-4 text-center">Nos interventions par ville dans le Rhône (69)</h4>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-3">
            {villes.map((ville) => (
              <a
                key={ville.href}
                href={ville.href}
                className="text-sm text-gray-600 hover:text-teal-600 transition-colors text-center py-2 px-3 rounded-lg hover:bg-teal-50"
              >
                {ville.name}
              </a>
            ))}
          </div>
        </div>

        <div className="border-t border-gray-300 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-600 text-sm text-center md:text-left">
              © {new Date().getFullYear()} Fenêtres Lyon - Tous droits réservés
            </p>
            <div className="flex flex-wrap justify-center gap-6 text-sm">
              <a href="/mentions-legales" className="text-gray-600 hover:text-teal-600 transition-colors">
                Mentions légales
              </a>
              <a href="/politique-confidentialite" className="text-gray-600 hover:text-teal-600 transition-colors">
                Politique de confidentialité
              </a>
              <a href="/cgv" className="text-gray-600 hover:text-teal-600 transition-colors">
                CGV
              </a>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-teal-600 transition-colors">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
